import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=a7db64ae&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports